import { useStore } from "@store/index"

const useAvatarKnowledgePreviewStore = (avatarId: string) => {
  const { knowledgePreviewStore } = useStore()
  return knowledgePreviewStore.getAnswersCollection(avatarId)
}

export default useAvatarKnowledgePreviewStore
